import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { store } from "@/stores/store";
import { NotificationService } from "@/services/notification.service";
export default {
  name: "HeaderNotifications",
  data() {
    return {
      store,
      items: [],
      unread: 0,
      loading: false,
      unsubscribe: null
    };
  },
  async mounted() {
    await this.refreshCount();
    const uid = this.store?.currentUser?.id;
    if (uid) {
      this.unsubscribe = NotificationService.subscribe(uid, row => {
        this.unread += 1;
        this.items = [row, ...this.items].slice(0, 30);
        this.$toast?.add?.({
          severity: "info",
          summary: row.title,
          detail: row.body || "",
          life: 6000
        });
      });
    }
  },
  beforeUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    async refreshCount() {
      const {
        count
      } = await NotificationService.unreadCount();
      this.unread = count;
    },
    async opened() {
      this.loading = true;
      const {
        notifications
      } = await NotificationService.list();
      this.items = notifications;
      this.loading = false;
    },
    kindClass(n) {
      const a = n.meta?.action;
      return a === "approve" ? "ok" : a === "reject" ? "bad" : "warn";
    },
    ago(iso) {
      const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
      if (s < 60) return "just now";
      if (s < 3600) return Math.floor(s / 60) + " min ago";
      if (s < 86400) return Math.floor(s / 3600) + " h ago";
      if (s < 7 * 86400) return Math.floor(s / 86400) + " d ago";
      return new Date(iso).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short"
      });
    },
    async open(n) {
      if (!n.read_at) {
        n.read_at = new Date().toISOString();
        this.unread = Math.max(0, this.unread - 1);
        NotificationService.markRead(n.id);
      }
      if (n.link) {
        // same route with a new query (tracker deep link) needs a replace to re-run mounted()
        const target = n.link;
        if (this.$route.fullPath === target) return;
        if (this.$route.path === target.split("?")[0]) {
          await this.$router.replace({
            path: "/management"
          });
        }
        this.$router.push(target);
      }
    },
    async markAll() {
      await NotificationService.markAllRead();
      this.items = this.items.map(n => ({
        ...n,
        read_at: n.read_at || new Date().toISOString()
      }));
      this.unread = 0;
    }
  }
};